/**
 * Employee directory API client — accessible to all authenticated users
 */

import apiClient from '@/core/api/client'
import { PaginatedResponse } from '@/shared/types/common.types'

export interface DirectoryEmployee {
  id: string
  full_name: string
  email: string
  job_title: string | null
  department: string | null
  division_id: string | null
  division_name: string | null
  manager_id: string | null
  manager_name: string | null
}

const directoryApi = {
  getDirectory: async (params?: {
    search?: string
    department?: string
    division_id?: string
    page?: number
    limit?: number
  }): Promise<PaginatedResponse<DirectoryEmployee>> => {
    const response = await apiClient.get('/v1/users/directory', { params })
    return {
      data: response.data.employees,
      pagination: response.data.pagination,
    }
  },
}

export default directoryApi
